<div class="section-chart" [class.has-secondary-axis]="sectionsEditorService.secondaryField()">
  <div class="axis-label primary">
    {{ sectionsEditorService.getWorkoutModeLabel(sectionsEditorService.primaryField().type) }}
  </div>
  @if (sectionsEditorService.secondaryField(); as secondaryField) {
    <div class="axis-label secondary">
      {{ sectionsEditorService.getWorkoutModeLabel(secondaryField.type) }}
    </div>
  }
  <div class="axis y-axis">
    @for (tick of ticks(); track $index) {
      <div class="tick">{{ tick }} {{ sectionsEditorService.getWorkoutModeUnit(mode()) }}</div>
    }
  </div>
  @if (sectionsEditorService.secondaryField(); as secondaryField) {
    <div class="axis y-axis-secondary">
      @for (tick of secondaryTicks(); track $index) {
        <div class="tick">
          {{ tick }} {{ sectionsEditorService.getWorkoutModeUnit(secondaryField.type) }}
        </div>
      }
    </div>
  }
  <div #timebar class="axis x-axis">
    <div #timeline class="timeline">
      @for (tick of timeTicks(); track tick.seconds) {
        <div class="tick" [style.left.%]="tick.percent">{{ tick.label }}</div>
      }
    </div>
  </div>
  <div class="content">
    <div
      class="blocks"
      cdkDropList
      cdkDropListOrientation="horizontal"
      (cdkDropListDropped)="drop($event)"
    >
      @for (section of sections(); track section.id) {
        <app-section-block
          cdkDrag
          cdkDragLockAxis="x"
          cdkDragBoundary=".blocks"
          [section]="section"
          [mode]="mode()"
          [previousSection]="sections()[$index - 1]"
          [timelineDuration]="timelineDuration()"
          (sectionChangeStart)="onSectionChangeStart()"
          (sectionChange)="sectionChange.emit({ sectionId: section.id, change: $event })"
          (sectionChangeEnd)="onSectionChangeEnd()"
        />
      }

      @if (sectionsEditorService.selectedSectionsIds().length === 0) {
        <button [disabled]="disabled()" class="create-new-section" (click)="createSection.emit()">
          <kin-icon [size]="32" name="add" />
        </button>
      } @else {
        <button
          [disabled]="disabled()"
          class="create-new-section duplicate"
          (click)="duplicateSections.emit()"
        >
          <kin-icon name="duplicate" [color]="colorService.brandSecondary()" />
        </button>
      }
    </div>
  </div>
</div>
